module.exports = __webpack_public_path__ + "media/images/favicon-6fe21dfebbdacc3115fa246b7a8ef4e2.ico";